import BaseService from "./BaseService";
import axiosInstance from "./axiosConfig";

class AttachmentService {
  static async getQuotationAttachments(quotationId, tennantId, token, page = 1, pageSize = 10) {
    try {
      const params = {
        page,
        pageSize,
        tennantId
      };
      return await BaseService.get(`ofertas/${quotationId}/attachments`, token, params);
    } catch (error) {
      console.error("Erro ao buscar anexos da cotação!", error);
      throw error;
    }
  }

  static async getOrderAttachments(orderId, tennantId, token, page = 1, pageSize = 10) {
    try {
      const params = {
        page,
        pageSize,
        tennantId
      };
      return await BaseService.get(`pedidos/${orderId}/attachments`, token, params);
    } catch (error) {
      console.error("Erro ao buscar anexos do pedido!", error);
      throw error;
    }
  }

  static async downloadAttachment(downloadUrl, fileName, token = null) {
    try {
      const response = await axiosInstance.get(downloadUrl, {
        headers: token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : undefined,
      });

      const downloadData = response?.data?.data?.[0];
      if (!downloadData?.downloadUrl) {
        throw new Error('Resposta inválida ao solicitar download do anexo');
      }
      
      const link = document.createElement('a');
      link.href = downloadData.downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
      
      return { success: true };
    } catch (error) {
      console.error("Erro ao baixar anexo!", error);
      throw error;
    }
  }
}

export default AttachmentService;